<template>
  <div>
    <success-fade-alert ref="alert" :msg="alert.success" />
    <fade-alert-danger ref="danger" :msg="alert.error" />
    <h2>Setores</h2>
    <router-link to="././create">
      <b-button size="sm">{{ $t("geral.create") }}</b-button>
    </router-link>

    <b-row>
      <b-table
        ref="table"
        class="table-nowrap"
        :busy.sync="isBusy"
        :items="myProvider"
        :sortBy="sortBy"
        :sortDesc="sortDesc"
        :fields="fields"
        :filter="tableFilters"
        :filter-debounce="500"
        :per-page="tablePerPage"
        :current-page="tableCurrentPage"
      >
        <template slot="thead-top" slot-scope="{ fields }">
          <b-tr>
            <b-th
              v-for="field in fields"
              :key="field.filterKey"
              class="vertical-align"
            >
              <div v-if="field.filterKey != 'actions'">
                <b-form-select
                  v-if="field.filterKey == 'active'"
                  v-model="tableFilters[field.filterKey]"
                  id="perPageSelect"
                  :options="activeOpt"
                ></b-form-select>
                <b-form-input
                  v-else
                  v-model="tableFilters[field.filterKey]"
                  :placeholder="'Buscar por ' + field.label"
                  class="idStyle"
                />
              </div>
            </b-th>
          </b-tr>
        </template>
        <template v-slot:cell(actions)="data">
          <!-- {{ data }} -->
          <router-link :to="`././edit/${data.item.id}`">
            <b-button size="sm" class="btn-checklist">
              {{ $t("geral.edit") }}
            </b-button>
          </router-link>
          <b-button
            size="sm"
            v-if="data.item.active"
            variant="danger"
            class="btn-checklist ml-2"
            @click="disableSector(data.item.id)"
          >
            {{ $t("geral.deactivate") }}
          </b-button>
          <b-button
            size="sm"
            v-if="!data.item.active"
            class="btn-checklist ml-2"
            @click="activateSector(data.item.id)"
          >
            {{ $t("geral.activate") }}
          </b-button>
        </template>
      </b-table>
    </b-row>
    <table-pagination-props
      :currentPage.sync="tableCurrentPage"
      :pageOptions.sync="tablePageOptions"
      :perPage.sync="tablePerPage"
      :rowCount.sync="tableRowCount"
    >
    </table-pagination-props>
  </div>
</template>
<script>
export default {
  name: "SectorList",
  components: {
    TablePaginationProps: () =>
      import("@/components_rms/base/TablePaginationProps.vue"),
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue")
  },
  data() {
    return {
      alert: {
        error: "",
        success: "Setor desativado com sucesso"
      },
      sortBy: "displayName",
      sortDesc: false,
      fields: [
        {
          key: "actions",
          filterKey: "actions",
          sortable: false,
          label: "",
          thStyle: { width: "125px" }
          // tdClass: "table-col-dinamic-width"
        },
        {
          key: "displayName",
          filterKey: "displayName",
          sortable: true,
          label: "Nome",
          thStyle: { width: "450px" }
          // tdClass: "table-col-dinamic-width"
        },
        {
          key: "active",
          filterKey: "active",
          sortable: true,
          label: "Ativo",
          thStyle: { width: "105px" },
          // tdClass: "table-col-dinamic-width",
          formatter: (value, key, item) => {
            if (value) {
              return "Sim";
            }
            return "Não";
          }
        }
      ],
      tableFilters: {
        displayName: "",
        active: "true"
      },
      activeOpt: [
        { value: "", text: "Todos" },
        { value: "true", text: "Sim" },
        { value: "false", text: "Não" }
      ],
      tableRowCount: 0,
      tablePerPage: 10,
      tablePageOptions: [5, 10, 25, 50, 100, 150],
      tableCurrentPage: 1,
      tableSelectMode: "single",
      tableSelectedItem: []
    };
  },
  methods: {
    myProvider(ctx, callback) {
      this.isBusy = true;
      // console.log(ctx);

      let apiParam = {
        currentPage: ctx.currentPage,
        perPage: ctx.perPage,
        active: ctx.filter.active,
        displayName: this.tableFilters.displayName,
        sortBy: ctx.sortBy,
        sortDesc: ctx.sortDesc
      };
      this.$apiScheduler
        .post("/sector/getAll/", apiParam)
        .then(response => {
          const items = response.data.items;
          this.isBusy = false;
          this.tableRowCount = response.data.totalItems;
          callback(items);
        })
        .catch(error => {
          console.log(error);
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
            this.isBusy = false;
            this.tableRowCount = 0;
            callback([]);
          }
        });
      return null;
    },
    disableSector(sectorId) {
      this.$apiScheduler
        .post("/sector/disable/" + sectorId)
        .then(response => {
          this.$refs.table.refresh();
          this.$refs.alert.show();
        })
        .catch(error => {
          console.log(error);
          this.submitted = false;
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
          }
        });
    },
    activateSector(sectorId) {
      this.$apiScheduler
        .post("/sector/activate/" + sectorId)
        .then(response => {
          this.$refs.table.refresh();
          this.$refs.alert.show();
        })
        .catch(error => {
          console.log(error);
          this.submitted = false;
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
          }
        });
    }
  }
};
</script>
